
import { JukeboxTypes } from '../constants/jukeboxConstants';

const initialState = {
    playing: ""
};

export const jukeboxReducer = (state = initialState, action) => {
    switch (action.type) {
        case JukeboxTypes.JUKEBOX_PLAY_YT:
            return {
                ...state,
                playing: action.videoId
            };
        case JukeboxTypes.JUKEBOX_STOP_YT:
            return {
                ...state,
                playing: ""
            };

        case 'RESET':
            return {...initialState};
        
        default:
            return state;
    }
};